/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Card, CardBody, CardHeader, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react';

import { createElement } from 'react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Label } from '../../../components/atoms/Label';
import { FaCartPlus, FaMobile, FaUsers } from 'react-icons/fa6';
import { FiFileText } from 'react-icons/fi';
import { MainTemplate } from '../../../templates/MainTemplate';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../../../components/organisms/Footer';

export function Partner() {
  const { name, colors } = useTheme();

  const navigate = useNavigate();
  const steps = [
    {
      title: 'Cadastre seu estabelecimento!',
      description: `Cadastre seu estabelecimento na ${name}!`,
      icon: FaMobile,
    },

    {
      title: 'Crie suas ofertas exclusivas',
      description: 'Ofertas com a cara do seu estabelecimento.',
      icon: FaCartPlus,
    },

    {
      title: 'Aumente sua base de clientes',
      description:
        'Se preocupe apenas com o seu estabelecimento, porque, clube de vantagens e marketing são os nossos negócios.',
      icon: FaUsers,
    },
  ];

  const features = [
    'Personalização de ofertas e dados do estabelecimento.',
    'Sistema de acompanhamento de pedidos e descontos integrado ao app.',
    `Conheça melhor quem são seus clientes e use as ferramentas de marketing ${name}! para aumentar ainda mais a sua base`,
  ];

  return (
    <MainTemplate>
      <VStack
        padding="0px 20px"
        marginBottom={{
          base: '100px',
          md: '0px',
        }}
        spacing={5}
        align={'flex-start'}
        width={'100%'}
        paddingTop={'20px'}
      >
        <Card width={'100%'}>
          <Flex
            flexDir={{
              base: 'column',
              md: 'row',
            }}
            align={'center'}
            width={'100%'}
          >
            <Box width={{ base: '100%', md: '60%' }} textAlign={'start'}>
              <CardHeader paddingBottom={0} margin={'auto'}>
                <Heading fontSize={'26px'} margin="auto">
                  Clube de Vantagens {name}
                </Heading>
              </CardHeader>
              <CardBody gap={2} display={'flex'} flexDir={'column'}>
                <Label width={'100%'}>
                  Que tal cadastrar o seu estabelecimento como parceiro do nosso Clube de Vantagens? É gratuito, basta
                  disponibilizar um desconto real para o cliente final.
                </Label>
                <Label width={'100%'}>
                  Inscreva a sua loja, seja divulgado para toda a nossa base e aumente as suas vendas!
                </Label>
              </CardBody>
            </Box>
            <Box flexGrow={1} alignItems={'center'} marginBottom="20px" display={'flex'} justifyContent={'center'}>
              <Box
                onClick={() => navigate('/cadastro-parcerias')}
                background={colors.primaryColor}
                borderRadius={'15px'}
                color="white"
                cursor={'pointer'}
                _hover={{
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out',
                }}
                padding={'15px'}
              >
                <VStack>
                  <FiFileText size={'30px'} />
                  <Text fontWeight={'bold'} fontSize={'20px'}>
                    Cadastrar-se agora!
                  </Text>
                </VStack>
              </Box>
            </Box>
          </Flex>
        </Card>

        <Card width={'100%'}>
          <CardHeader>
            <Heading fontSize={'26px'} textAlign="center">
              Como funciona?
            </Heading>
          </CardHeader>
          <CardBody>
            <Flex
              flexDirection={{
                base: 'column',
                md: 'row',
              }}
              gap={10}
              align={'flex-start'}
              width={'100%'}
            >
              {steps.map((step, index) => (
                <VStack key={index} spacing={2} align={'center'} width={'100%'}>
                  {createElement(step.icon, { size: '45px', color: colors.primaryColor })}
                  <Heading fontSize={'18px'}>{step.title}</Heading>
                  <Text textAlign={'center'}>{step.description}</Text>
                </VStack>
              ))}
            </Flex>
          </CardBody>
        </Card>
        {
          <VStack spacing={6} maxWidth={600} margin={'auto'} align={'flex-start'} width={'100%'}>
            <Heading fontSize={'21px'} margin="auto">
              Recursos para sua Marca
            </Heading>
            {features.map((feature, index) => (
              <Card
                _hover={{
                  transform: 'scale(1.05)',
                  transition: 'transform 0.3s ease-in-out',
                }}
                backgroundColor={colors.primaryColor}
                width={'100%'}
                key={index}
              >
                <CardBody>
                  <Text color="white" fontSize={16} fontWeight={'bold'} textAlign={'center'}>
                    {feature}
                  </Text>
                </CardBody>
              </Card>
            ))}
          </VStack>
        }
        <Footer />
      </VStack>
    </MainTemplate>
  );
}
